module.exports = __webpack_public_path__ + "static/media/Forty.58a8d04a.ogg";